import {
  DashboardInsightsResponseSchema,
  ProductsBreakdownResponseSchema,
  WebsiteBreakdownResponseSchema,
  WebsiteHealthResponseSchema,
} from '@utazzo/shared';

import type {
  DashboardPeriod,
  ProductsBreakdownResponse,
  WebsiteBreakdownResponse,
  WebsiteHealthResponse,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const getDashboardInsights = async (period: DashboardPeriod = 'mtd') => {
  const { data } = await apiClient.get<unknown>('/dashboard/insights', {
    params: { period },
  });
  return DashboardInsightsResponseSchema.parse(data);
};

export const getWebsiteHealth = async (): Promise<WebsiteHealthResponse> => {
  const { data } = await apiClient.get<unknown>('/dashboard/website-health');
  return WebsiteHealthResponseSchema.parse(data);
};

export const getWebsiteBreakdown = async (): Promise<WebsiteBreakdownResponse> => {
  const { data } = await apiClient.get<unknown>('/dashboard/website-breakdown');
  return WebsiteBreakdownResponseSchema.parse(data);
};

export const getProductsBreakdown = async (): Promise<ProductsBreakdownResponse> => {
  // This endpoint scans the whole catalog, so on a cold cache / busy DB it can
  // take a while. Disable the client timeout (0 = no limit) so a slow response
  // keeps showing the loading state rather than surfacing a timeout error - we
  // would rather wait than fail (product decision 2026-10-11).
  const { data } = await apiClient.get<unknown>('/dashboard/products-breakdown', { timeout: 0 });
  return ProductsBreakdownResponseSchema.parse(data);
};
